import type { RouteRecord } from 'vite-react-ssg'
import { lazy } from 'react'
import RootLayout from './components/RootLayout'
import App from './App'

const Impressum = lazy(() => import('./pages/Impressum'))
const Datenschutz = lazy(() => import('./pages/Datenschutz'))
const AGB = lazy(() => import('./pages/AGB'))
const CookieRichtlinie = lazy(() => import('./pages/CookieRichtlinie'))
const Leistungen = lazy(() => import('./pages/Leistungen'))
const KiTelefonassistent = lazy(() => import('./pages/KiTelefonassistent'))
const Prozessautomatisierung = lazy(() => import('./pages/Prozessautomatisierung'))
const KiIntegration = lazy(() => import('./pages/KiIntegration'))
const Kostenoptimierung = lazy(() => import('./pages/Kostenoptimierung'))
const KiBeratungWien = lazy(() => import('./pages/KiBeratungWien'))
const Referenzen = lazy(() => import('./pages/Referenzen'))
const UeberUns = lazy(() => import('./pages/UeberUns'))
const Kontakt = lazy(() => import('./pages/Kontakt'))
const Sitemap = lazy(() => import('./pages/Sitemap'))
const NotFound = lazy(() => import('./pages/NotFound'))
const EnHome = lazy(() => import('./pages/en/Home'))
const EnServices = lazy(() => import('./pages/en/Services'))
const EnAiPhoneAssistant = lazy(() => import('./pages/en/AiPhoneAssistant'))
const EnProcessAutomation = lazy(() => import('./pages/en/ProcessAutomation'))
const EnAiIntegration = lazy(() => import('./pages/en/AiIntegration'))
const EnCostOptimization = lazy(() => import('./pages/en/CostOptimization'))
const EnAiConsultingVienna = lazy(() => import('./pages/en/AiConsultingVienna'))
const EnReferences = lazy(() => import('./pages/en/References'))
const EnAboutUs = lazy(() => import('./pages/en/AboutUs'))
const EnContact = lazy(() => import('./pages/en/Contact'))

export const routes: RouteRecord[] = [
  {
    path: '/',
    element: <RootLayout />,
    children: [
      { index: true, element: <App /> },
      { path: 'leistungen', element: <Leistungen /> },
      { path: 'leistungen/ki-telefonassistent', element: <KiTelefonassistent /> },
      { path: 'leistungen/prozessautomatisierung', element: <Prozessautomatisierung /> },
      { path: 'leistungen/ki-integration', element: <KiIntegration /> },
      { path: 'leistungen/kostenoptimierung', element: <Kostenoptimierung /> },
      { path: 'ki-beratung-wien', element: <KiBeratungWien /> },
      { path: 'referenzen', element: <Referenzen /> },
      { path: 'ueber-uns', element: <UeberUns /> },
      { path: 'kontakt', element: <Kontakt /> },
      { path: 'impressum', element: <Impressum /> },
      { path: 'datenschutz', element: <Datenschutz /> },
      { path: 'agb', element: <AGB /> },
      { path: 'cookie-richtlinie', element: <CookieRichtlinie /> },
      { path: 'sitemap', element: <Sitemap /> },
      { path: 'en', element: <EnHome /> },
      { path: 'en/services', element: <EnServices /> },
      { path: 'en/services/ai-phone-assistant', element: <EnAiPhoneAssistant /> },
      { path: 'en/services/process-automation', element: <EnProcessAutomation /> },
      { path: 'en/services/ai-integration', element: <EnAiIntegration /> },
      { path: 'en/services/cost-optimization', element: <EnCostOptimization /> },
      { path: 'en/ai-consulting-vienna', element: <EnAiConsultingVienna /> },
      { path: 'en/references', element: <EnReferences /> },
      { path: 'en/about-us', element: <EnAboutUs /> },
      { path: 'en/contact', element: <EnContact /> },
      { path: '*', element: <NotFound /> },
    ],
  },
]
